/**
 * Route for `campaign-os-targeting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignOsTargetingPage } from "../features/campaign-os-targeting/CampaignOsTargetingPage";

export const campaignOsTargetingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-os-targeting",
	component: CampaignOsTargetingPage,
});

export default campaignOsTargetingRoute;
